<form [formGroup]="formGroup">
  @if (isLoading) {
    <div class="spinner-container p-absolute">
      <lib-loading-column-animation></lib-loading-column-animation>
    </div>
  }
  <div class="chart-settings ml-4 mb-0 mt-4 mr-3">
    @if (textHeader) {
      <h2>{{ textHeader }}</h2>
    }
    @if (itemCharts.length > 1) {
      <mat-button-toggle-group class="wrappable-group" [formControl]="formGroup.controls.id" name="fontStyle">
        @for (chart of itemCharts; track chart) {
          @switch (chart.type) {
            @case (ChartType.Distribution) {
              <mat-button-toggle data-type="distribution" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || 'research.distribution' | transloco
              }}</mat-button-toggle>
            }
            @case (ChartType.Trend) {
              <mat-button-toggle data-type="trend" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.trend' | transloco)
              }}</mat-button-toggle>
            }
            @case (ChartType.Comparison360) {
              <mat-button-toggle data-type="360" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.360' | transloco)
              }}</mat-button-toggle>
            }
            @case (ChartType.Table) {
              <mat-button-toggle data-type="table" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.table' | transloco)
              }}</mat-button-toggle>
            }
            @case (ChartType.Spider) {
              <mat-button-toggle data-type="spider" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.spider' | transloco)
              }}</mat-button-toggle>
            }
            @case (ChartType.VerticalColorful) {
              <mat-button-toggle data-type="vertical_colorful" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.vertical_colorful' | transloco)
              }}</mat-button-toggle>
            }
            @case (ChartType.HorizontalStacked) {
              <mat-button-toggle data-type="horizontal_stacked" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.horizontal_stacked' | transloco)
              }}</mat-button-toggle>
            }
            @case (ChartType.VerticalStacked) {
              <mat-button-toggle data-type="vertical_stacked" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.vertical_stacked' | transloco)
              }}</mat-button-toggle>
            }
            @case (ChartType.HorizontalColorful) {
              <mat-button-toggle data-type="horizontal_colorful" [attr.data-id]="chart.id" [value]="chart.id">{{
                getItemTitle(chart.title) || ('research.horizontal_colorful' | transloco)
              }}</mat-button-toggle>
            }
          }
        }
      </mat-button-toggle-group>
    }

    <div class="chart-settings-pair ml-auto">
      @if (isSelectVisible()) {
        <lib-select
          [options]="chartSelectOptions"
          placeholder="Labels"
          [noBackground]="true"
          [value]="formGroup.controls.label.value"
          (valueChange)="formGroup.controls.label.setValue($event)"
        ></lib-select>
      }
      @if (activeChart.chartExportData && isData) {
        <lib-dropdown-list class="ml-auto">
          <ng-template #rows>
            <li (click)="exportChart('image/png')">
              <span>{{ 'research.download_PNG_image' | transloco }}</span>
            </li>
            <li (click)="exportChart('image/jpeg')">
              <span>{{ 'research.download_JPEG_image' | transloco }}</span>
            </li>
            <li (click)="exportChart('application/pdf')">
              <span>{{ 'research.download_PDF_document' | transloco }}</span>
            </li>
            <li (click)="exportChart('image/svg+xml')">
              <span>{{ 'research.download_SVG_vector_image' | transloco }}</span>
            </li>
          </ng-template>
          <ng-template #trigger>
            <span class="hamburger-icon" inlineSVG="/icons/icon-hamburger-no-color.svg"></span>
          </ng-template>
        </lib-dropdown-list>
      }
    </div>
  </div>

  <div class="chart-container mt-3" [attr.data-type]="activeChart.item.type">
    @if (isData) {
      <ng-content></ng-content>
    } @else {
      <div class="no-data" [ngStyle]="{ visibility: isLoading ? 'hidden' : 'visible' }">
        <span class="chart-icon" [inlineSVG]="'/icons/icon-column-chart.svg'"></span>
        <p>
          {{ 'research.not_enough_people' | transloco }} <br />
          {{ 'research.chart_can_not_be_rendered' | transloco }}
        </p>
      </div>
    }
  </div>
</form>
